import React from "react";

const ErrorIcon = props => (
    <svg {...props} fill="currentcolor" version="1.1" width="24" height="24" viewBox="0 0 24 24">    
        <path d="M18.696 4.992c-1.663-1.661-3.959-2.688-6.495-2.688-5.077 0-9.192 4.115-9.192 9.192s4.115 9.192 9.192 9.192c2.536 0 4.832-1.027 6.496-2.688 1.663-1.665 2.691-3.964 2.691-6.504s-1.029-4.839-2.692-6.504zM11.496 5.484h1.908c0.576 0 0.66 0.336 0.66 0.528v0.372l-0.396 6.984c0 0.528-0.288 0.624-0.672 0.624h-0.996c-0.384 0-0.624-0.108-0.672-0.636l-0.396-6.96v-0.396c-0.012-0.18 0.072-0.516 0.612-0.516zM12.48 18.9c-0.994 0-1.8-0.806-1.8-1.8s0.806-1.8 1.8-1.8c0.994 0 1.8 0.806 1.8 1.8-0.006 0.975-0.781 1.767-1.749 1.8z"></path>
    </svg>
);

export default ErrorIcon;